<template>
  <div id="lead-member-info">
    <img
      src="@shared/assets/img/logo/black-logo.png"
      alt="SmartAC.com"
      class="logo"
    >
    <div>
      <div class="ld-title">
        {{ alertTitle(alert.title) }}
      </div>
      <div class="ld-border" />
    </div>
    <div class="ld-customer-info">
      <div>{{ customer.firstName }} {{ customer.lastName }}</div>
      <div>{{ address.address1 }}</div>
      <div>{{ address.city }}, {{ address.state }} {{ address.zip }}</div>
      <div>{{ customer.phone }}</div>
      <div>{{ customer.email }}</div>
    </div>
  </div>
</template>

<script>
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'MemberInfoPdf',
  mixins: [leadDetailMixin],
  methods: {
    alertTitle(title) {
      let value = title;
      if (title === 'Water Detected') {
        value = 'Water Leak Detected';
      }
      return value;
    },
  },
};
</script>

<style lang="scss">

#lead-member-info {
  display: grid;
  align-content: space-between;
  padding: 2rem;

  .logo {
    width: 61pt;
    margin-bottom: 6px;
  }

  .ld-title {
    font-size: 30pt;
    line-height: 1.2;
    font-weight: 500;
  }

  .ld-border {
    width: 81px;
    height: 2px;
    margin-top: 20px;
    background-color: $N110;
  }

  .ld-customer-info {
    font-size: 10pt;
  }
}
</style>
